const SUPPORTED = ['en', 'fr'];

// Resolve the initial UI locale: an explicit ?lang= value (shareable links, e.g. /cams?lang=fr)
// wins, else the user's stored choice from the language toggle. Only 'en'/'fr' are supported;
// anything else is ignored and we fall back to 'en'.
export const resolveInitialLocale = ({ urlLang, stored } = {}) =>
  [(urlLang || '').toLowerCase(), stored].find(l => SUPPORTED.includes(l)) || 'en';

// Append the active locale as ?lang= so it survives navigation the CAMS pages trigger,
// notably the cross-domain hop to payaccount.io where sessionStorage does not carry.
export const withLang = (url, locale) => {
  if (!url || !SUPPORTED.includes(locale)) return url;
  return `${url}${url.includes('?') ? '&' : '?'}lang=${locale}`;
};
